import moment from 'moment';
import { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import ReactSelect from "react-select";
import calLogo from '../../assets/images/calender.svg';
import Button from "../../components/ui/Button";
import Skeleton from "../../components/ui/Skeleton";
import { ApiConstants } from "../../constants/ApiConstants";
import { ApiTypes } from "../../constants/Constants";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { getDateHelper, getFrequencyDates, getPriceHelper, setDateHelper } from "../../utils/Helper";
import chevRight from '../../assets/images/chev-right.svg'
import SortIcon from '../../assets/images/sort-icon.svg'
import viewOn from '../../assets/images/view-on-icon.svg'
import dummyUser from "../../assets/images/menu/account.svg";
import CustomReactSelect from '../../components/ui/CustomReactSelect';



const ExpensesReport = ({ payers }: any) => {

    let profile: any = useContext(authContext);
    profile = profile?.data;
    const expenses = useMakeRequest();
    const expensesCategories = useMakeRequest();
    const hhMembers = useMakeRequest();
    const updateExpense = useMakeRequest();

    const [isExpenseChartExpanded, setIsExpenseChartExpanded] = useState(true);

    const [expensesList, setExpensesList] = useState<any[]>([]);
    const [sharedBetweenMemb, setSharedBetweenMemb] = useState([]);

    const [expensesFilter, setExpensesFilter]: any = useState();
    const [expPaidMembWise, setExpPaidMembWise] = useState([])

    const [filteredExpensesList, setFilteredExpensesList] = useState<any[]>([]);
    const [filteredExpPaidMembWise, setFilteredExpPaidMembWise]: any = useState([])

    const [totalExpPaid, setTotalExpPaid] = useState(0)
    const [totalExpUnPaid, setTotalExpUnPaid] = useState(0)
    const [totalExp, setTotalExp] = useState(0)

    const [filteredTotalExpPaid, setFilteredTotalExpPaid] = useState(0)
    const [filteredTotalExpUnPaid, setFilteredTotalExpUnPaid] = useState(0)
    const [filteredTotalExp, setFilteredTotalExp] = useState(0)

    const [deleteData, setDeleteData]: any = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });


    const [expandedSections, setExpandedSections] = useState<{ [key: string]: boolean }>({
        totalHours: false,
        totalExpenses: false,
        totalPaid: false,
        totalUnpaid: false,
        currentBalances: false,
        finalizedBalances: false
    });


    const getExpenses = () => {
        const fetch = async () => {
            setIsLoading(true)
            await expenses.makeRequest({ url: ApiConstants?.ExpensesGet })
            setExpensesFilter({
                ec_id: null,
                payer: null,
                s_date: null,
                e_date: null,
                amount: ''
            });
        }
        fetch()
    }

    useEffect(() => {
        if (expenses?.status && hhMembers?.status) {
            const expensesRows = expenses?.data?.data?.rows;
            const modifiedExpenses = expenses?.data?.data?.modified_expenses;
            let expensesArr: any = [];

            const expPaidMembWiseArr: any = {};
            let totalExpensesPaid = 0;
            let totalExpensesUnPaid = 0;
            let totalExpenses = 0;

            hhMembers?.data?.data?.forEach((member: any) => {
                const userUUID = member?.user?.uuid;
                if (userUUID) {
                    expPaidMembWiseArr[userUUID] = {
                        name: member?.user?.name,
                        profile_pic: member?.user?.profile_pic,
                        email: member?.user?.email,
                        expenses_paid: 0
                    };
                }
            });

            expPaidMembWiseArr['joint_account'] = {
                name: 'Joint Accounts',
                profile_pic: null,
                email: null,
                expenses_paid: 0
            };

            if (expensesRows?.length > 0) {
                expensesRows.forEach((exp: any) => {
                    const freqDays = getFrequencyDates(
                        exp?.s_date,
                        exp?.e_date,
                        exp?.f_type,
                        exp?.f_value,
                        exp?.s_days_or_months
                    );

                    const mappedExpenses = freqDays.map((date: string) => {
                        const modifiedExpense = modifiedExpenses.find(
                            (modExp: any) => moment(modExp.m_date).format('YYYY-MM-DD') === date && modExp.e_id === exp.id
                        );

                        if (modifiedExpense && modifiedExpense.is_deleted) {
                            return null;
                        }

                        const isUnpaid = modifiedExpense ? modifiedExpense.is_unpaid === 1 : exp?.is_unpaid === 1;
                        const amount = modifiedExpense?.amount || exp?.amount;

                        if (modifiedExpense) {
                            return {
                                ...exp,
                                ...modifiedExpense,
                                paid_by: modifiedExpense?.payer === 0 ? { value: 0, label: 'Unpaid' } : modifiedExpense?.paid_by,
                                date,
                                is_modified: true,
                                is_unpaid: isUnpaid,
                                amount
                            };
                        } else {
                            return {
                                date,
                                ...exp,
                                paid_by: exp?.payer === 0 ? { value: 0, label: 'Unpaid' } : exp?.paid_by,
                                is_modified: false,
                                is_unpaid: isUnpaid,
                                amount
                            };
                        }
                    }).filter(Boolean);

                    expensesArr.push(...mappedExpenses);
                    mappedExpenses.forEach((expense: any) => {
                        const totalAmount = Number(expense.amount);

                        if (expense.is_unpaid) {
                            totalExpensesUnPaid += totalAmount;
                        } else {
                            totalExpensesPaid += totalAmount;

                            // Check if it's a joint account expense
                            if (expense.is_joint_account || expense.paid_by?.value === "01" || expense.paid_by?.label?.toLowerCase().includes("joint")) {
                                expPaidMembWiseArr['joint_account'].expenses_paid += totalAmount;
                            } else {
                                const payerUUID = expense.paid_by?.value;
                                if (payerUUID && payerUUID !== 0 && expPaidMembWiseArr[payerUUID]) {
                                    expPaidMembWiseArr[payerUUID].expenses_paid += totalAmount;
                                }
                            }
                        }
                        totalExpenses += totalAmount;
                    });
                });
                expensesArr.sort((a: any, b: any) => moment(a.date).valueOf() - moment(b.date).valueOf());
            }

            setTotalExpPaid(totalExpensesPaid);
            setTotalExpUnPaid(totalExpensesUnPaid);
            setTotalExp(totalExpenses);

            setFilteredTotalExpPaid(totalExpensesPaid);
            setFilteredTotalExpUnPaid(totalExpensesUnPaid);
            setFilteredTotalExp(totalExpenses);

            setExpPaidMembWise(expPaidMembWiseArr);
            setFilteredExpPaidMembWise(expPaidMembWiseArr);
            setExpensesList(expensesArr);
            setFilteredExpensesList(expensesArr);
            setIsLoading(false)
        }
    }, [expenses?.status, hhMembers?.status]);


    useEffect(() => {
        getExpenses()
        hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers })
        expensesCategories.makeRequest({ url: ApiConstants?.ExpensesCategoriesGet, type: ApiTypes?.GET });
    }, [updateExpense?.status])

    const handleTableScroll = () => {
        return
    }
    const handleFilter = (type: string = 'FILTER') => {

        if (type === 'RESET') {
            setExpensesFilter({
                ec_id: null,
                payer: null,
                s_date: null,
                e_date: null,
                amount: ''
            });

            setFilteredExpensesList(expensesList);
            setFilteredExpPaidMembWise(expPaidMembWise);

            setFilteredTotalExpPaid(totalExpPaid);
            setFilteredTotalExpUnPaid(totalExpUnPaid);
            setFilteredTotalExp(totalExp);

            return;
        }

        let { ec_id, payer, s_date, e_date, amount } = expensesFilter || {};

        const categoryId = ec_id?.value;
        const payerId = payer?.value;

        const filteredExpenses = expensesList.filter((expense: any) => {

            let isMatch = true;

            const expenseDate = moment(expense?.date);

            // ✅ Date filtering (inclusive)
            if (s_date && e_date) {
                if (
                    expenseDate.isBefore(moment(s_date).startOf('day')) ||
                    expenseDate.isAfter(moment(e_date).endOf('day'))
                ) {
                    isMatch = false;
                }
            } else if (s_date) {
                if (expenseDate.isBefore(moment(s_date).startOf('day'))) {
                    isMatch = false;
                }
            } else if (e_date) {
                if (expenseDate.isAfter(moment(e_date).endOf('day'))) {
                    isMatch = false;
                }
            }

            // ✅ Category filter
            if (categoryId && expense?.expense_cat?.value !== categoryId) {
                isMatch = false;
            }

            // ✅ Payer filter (handles member / unpaid / joint)
            if (payerId) {

                console.log("payerId; ", payerId)
                console.log("expense ", expense)

                // 🔹 Unpaid selected
                if (payerId === "0") {
                    if (expense?.paid_by?.value !== 0) {
                        isMatch = false;
                    }
                }

                // 🔹 Joint Account selected
                else if (payerId === "01") {
                    if (expense?.is_joint_account !== 1 || expense?.is_unpaid === 1) {
                        isMatch = false;
                    }
                }

                // 🔹 Normal member selected
                else {
                    if (
                        expense?.is_unpaid === 1 ||
                        expense?.is_joint_account === 1 ||
                        expense?.paid_by?.value !== payerId
                    ) {
                        isMatch = false;
                    }
                }
            }

            // ✅ Amount filter
            if (amount && Number(expense?.amount) !== Number(amount)) {
                isMatch = false;
            }

            return isMatch;
        });

        // ===============================
        // Totals Calculation
        // ===============================

        let totalExpensesPaid = 0;
        let totalExpensesUnPaid = 0;

        const expPaidMembWiseArr: any = {};

        hhMembers?.data?.data?.forEach((member: any) => {
            const userUUID = member?.user?.uuid;

            if (userUUID) {
                expPaidMembWiseArr[userUUID] = {
                    name: member?.user?.name,
                    profile_pic: member?.user?.profile_pic,
                    email: member?.user?.email,
                    expenses_paid: 0
                };
            }
        });

        expPaidMembWiseArr['joint_account'] = {
            name: 'Joint Accounts',
            profile_pic: null,
            email: null,
            expenses_paid: 0
        };

        filteredExpenses.forEach((expense: any) => {

            if (expense.is_unpaid === 1) {
                totalExpensesUnPaid += Number(expense.amount);
            } else {
                totalExpensesPaid += Number(expense.amount);

                // Joint account expense
                if (expense.is_joint_account === 1 || expense.paid_by?.value === "01" || expense.paid_by?.label?.toLowerCase().includes("joint")) {
                    expPaidMembWiseArr['joint_account'].expenses_paid += Number(expense.amount);
                }
                // Member expense
                else {
                    const payerUUID = expense.paid_by?.value;

                    if (payerUUID) {
                        if (!expPaidMembWiseArr[payerUUID]) {
                            expPaidMembWiseArr[payerUUID] = {
                                name: expense.paid_by?.label,
                                expenses_paid: 0
                            };
                        }

                        expPaidMembWiseArr[payerUUID].expenses_paid += Number(expense.amount);
                    }
                }
            }
        });

        setFilteredTotalExpPaid(totalExpensesPaid);
        setFilteredTotalExpUnPaid(totalExpensesUnPaid);
        setFilteredTotalExp(totalExpensesPaid + totalExpensesUnPaid);

        setFilteredExpensesList(filteredExpenses);
        setFilteredExpPaidMembWise(expPaidMembWiseArr);
    };

    const handleSort = (key: any) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const toggleSection = (section: string) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    }

    return (
        <>
            <div className="page-padding-x box-bg pt-2">
                <div className="com-input-grp mb-4 mt-2">
                    <div className="input-header">
                        <label className="form-label-large">Expense Chart</label>
                        <div className="filter-section" onClick={() => setIsExpenseChartExpanded(!isExpenseChartExpanded)} style={{ cursor: 'pointer' }}>
                            <span>Filter</span>
                            <img
                                src={chevRight}
                                alt="chevron"
                                style={{
                                    transform: isExpenseChartExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease'
                                }}
                            />
                        </div>
                    </div>
                </div>

                {isExpenseChartExpanded && (
                    <>
                        <div className="row gy-3">
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">Start Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="Select Date"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={expensesFilter?.s_date ? moment(expensesFilter?.s_date).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setExpensesFilter({ ...expensesFilter, s_date: setDateHelper({ date: start_date }), e_date: '' })
                                        }}
                                        minDate={moment(profile?.hh_member?.billing_date).toDate()}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">End Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="Select Date"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={expensesFilter?.e_date ? moment(expensesFilter?.e_date).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setExpensesFilter({ ...expensesFilter, e_date: setDateHelper({ date: start_date }) })
                                        }}
                                        minDate={new Date(new Date(expensesFilter?.s_date).setDate(new Date(expensesFilter?.s_date).getDate() + 1))}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <CustomReactSelect
                                    label="Expense Type"
                                    value={expensesFilter?.ec_id}
                                    options={[
                                        ...(Array.isArray(expensesCategories?.data?.data) ? expensesCategories?.data?.data : []),
                                    ]}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Select Expense Type"
                                    isLoading={expensesCategories?.loading}
                                    onChange={(selectedOption: any) => {
                                        setExpensesFilter({ ...expensesFilter, ec_id: selectedOption })
                                    }}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />
                            </div>
                            <div className="col-6">
                                <CustomReactSelect
                                    label="Payer"
                                    value={expensesFilter?.payer}
                                    options={[
                                        ...(Array.isArray(payers) ? payers : []),
                                    ]}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Select Payer"
                                    onChange={(selectedOption: any) => {
                                        setExpensesFilter({ ...expensesFilter, payer: selectedOption })
                                    }}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />
                            </div>
                            <div className="col-12">
                                <div className="com-input-grp">
                                    <label className="form-label">Amount</label>
                                    <div className='custom-select'>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Amount"
                                            value={expensesFilter?.amount}
                                            onInput={(e: any) => {
                                                let inputValue = e.target.value;
                                                inputValue = inputValue.replace(/[^0-9.]/g, '');
                                                const decimalCount = inputValue.split('.').length - 1;
                                                if (decimalCount > 1) {
                                                    const parts = inputValue.split('.');
                                                    inputValue = parts[0] + '.' + parts.slice(1).join('');
                                                }
                                                const parts = inputValue.split('.');
                                                if (parts[0].length > 7) {
                                                    parts[0] = parts[0].substring(0, 7);
                                                }
                                                if (parts.length > 1) {
                                                    parts[1] = parts[1]?.substring(0, 2);
                                                }
                                                inputValue = parts.join('.');
                                                e.target.value = inputValue;
                                                setExpensesFilter({ ...expensesFilter, amount: e.target.value })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='d-flex pt-2'>
                            <Button className='custom-grayed-btn modal-light-btn mt-2 me-4' type="button" style={{ width: '50%' }} onClick={() => handleFilter('RESET')}>Reset</Button>
                            <Button className='com-btn mt-2' type="button" style={{ width: '50%' }} onClick={handleFilter}>Filter</Button>
                        </div>
                    </>
                )}
            </div>
            <div className="box-bg pt-3">
                <div className="page-padding-x table-scroll-top" >
                    <div className='table-responsive table-y-scroll-2 report-table mb-2' onScroll={handleTableScroll}>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>Date
                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('date')}
                                        />
                                    </th>

                                    <th className="text-center">Expense Type
                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('exp_type')}
                                        />
                                    </th>
                                    <th className="text-center">Amount
                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('amount')}
                                        />
                                    </th>
                                    <th className="text-center">Payer
                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('payer')}
                                        />
                                    </th>
                                    <th className="text-center">Description
                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('description')}
                                        />
                                    </th>

                                    {/* <th className="text-center">Individual Share
                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('individual_share')}
                                        />
                                    </th> */}
                                    <th className="text-center">Shared Between

                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('shared_between')}
                                        />
                                    </th>
                                    <th className="text-center">Payment Status

                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('payment_status')}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    isLoading ?
                                        Array.from({ length: 10 })?.map(() => (
                                            <tr>

                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '100px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '140px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                                                </td>
                                            </tr>
                                        )) :

                                        filteredExpensesList?.length > 0 ?
                                            [...filteredExpensesList]
                                                ?.sort((a, b) => {
                                                    const { key, direction } = sortConfig;
                                                    if (!key) return 0;

                                                    let aValue, bValue;

                                                    switch (key) {
                                                        case 'date':
                                                            aValue = new Date(a.date);
                                                            bValue = new Date(b.date);
                                                            break;
                                                        case 'exp_type':
                                                            aValue = a.expense_cat?.label?.toLowerCase();
                                                            bValue = b.expense_cat?.label?.toLowerCase();
                                                            break;
                                                        case 'description':
                                                            aValue = a.desc?.toLowerCase();
                                                            bValue = b.desc?.toLowerCase();
                                                            break;
                                                        case 'amount':
                                                            aValue = a.amount?.toLowerCase();
                                                            bValue = b.amount?.toLowerCase();
                                                            break;
                                                        case 'payer':
                                                            aValue = a.paid_by?.label?.toLowerCase();
                                                            bValue = b.paid_by?.label?.toLowerCase();
                                                            break;
                                                        case 'shared_between':
                                                            aValue = a.shared_between[0].split_user?.name?.toLowerCase()
                                                            bValue = b.shared_between[0].split_user?.name?.toLowerCase()
                                                            break;
                                                        case 'payment_status':
                                                            aValue = a.is_unpaid ? 1 : 0;
                                                            bValue = b.is_unpaid ? 1 : 0;
                                                            break;
                                                        default:
                                                            return 0;
                                                    }

                                                    if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                                                    if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                                                    return 0;
                                                })?.map((expense: any, expenseIndex: any) => {
                                                    const date = getDateHelper({ date: expense?.date, format: 'MM/DD/YYYY' });
                                                    const desc = expense?.desc;
                                                    const payer = expense?.paid_by?.label;
                                                    const expCat = expense?.expense_cat?.label;
                                                    const amount = expense?.amount;
                                                    const sharedBetween = expense?.shared_between;
                                                    const individualShare = Number(amount) / expense?.shared_between?.length;
                                                    const paymentStatus = expense?.is_unpaid ? 'Unpaid' : 'Paid';
                                                    const jointAccountStatus = expense?.is_joint_account ? 'Joint Account' : payer;
                                                    return (
                                                        <>
                                                            <tr key={expenseIndex}>
                                                                <td className="text-center">{date}</td>
                                                                <td className="text-center">{expCat}</td>
                                                                <td className="text-center">{getPriceHelper(amount)}</td>
                                                                <td className="text-center">{jointAccountStatus}</td>
                                                                <td className="text-center">{desc}</td>
                                                                {/* <td className="text-center">{getPriceHelper(individualShare)}</td> */}
                                                                <td className="text-center">{"View"}{sharedBetween?.length >= 1 ?
                                                                    <>
                                                                        <button
                                                                            type='button'
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#sharedBetweenModal"
                                                                            className='view-shared'
                                                                            onClick={() => setSharedBetweenMemb(sharedBetween)}>
                                                                            <img className="calIcon ms-2" src={viewOn} alt="eye" />
                                                                        </button >
                                                                    </>
                                                                    : ''}</td>
                                                                <td className='pay-status'>{paymentStatus}</td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            :
                                            <>
                                                <tr>
                                                    <td colSpan={20} className="px-0">
                                                        <p className="text-center mt-2 mb-0 fw-500">No Record Found</p>
                                                    </td>
                                                </tr>
                                            </>
                                }
                                {/* <tr>
                                                <td className="text-center">
                                                    <div className="spinner-border" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </td>
                                            </tr> */}
                            </tbody>
                        </table>
                    </div>

                    {/* <button className="t-scroll-btn">Move to top</button> */}
                </div>

                <div className="divider" />

                <div className='summary-section'>
                    <h3 className='summary-title'>Summary</h3>

                    {/* Total Hours Projected */}
                    <div className='summary-item' tabIndex={0}>
                        <div className='summary-item-header'>
                            <span className='summary-item-label'>Total Expenses</span>
                            <span className='summary-item-value'>{getPriceHelper(filteredTotalExp) || 0}</span>
                        </div>
                    </div>

                    {/* Total Hours Completed */}
                    <div
                        className='summary-item'
                        tabIndex={0}
                        role='button'
                        aria-expanded={expandedSections.totalHours}
                        onClick={() => toggleSection('totalHours')}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                toggleSection('totalHours');
                            }
                        }}
                    >
                        <div className='summary-item-header'>
                            <div className='summary-item-left'>
                                <span className='summary-item-label'>Total Paid Expenses</span>
                                <span className='summary-item-arrow'>
                                    <img className={`accordion-arrow ${expandedSections.totalHours ? 'expanded' : ''}`} src={chevRight} alt="" />
                                </span>
                            </div>
                            <span className='summary-item-value'>
                                {getPriceHelper(filteredTotalExpPaid) || 0}
                            </span>
                        </div>
                    </div>
                    {expandedSections.totalHours && (
                        <div className='summary-item-expanded'>
                            {
                                Object.values(filteredExpPaidMembWise)?.length > 0 ? Object.values(filteredExpPaidMembWise)?.map((user: any, key: number) => (
                                    <div className='summary-sub-item' key={key}>
                                        <span className='summary-sub-label'>{user?.name?.toLowerCase().includes('joint') ? 'Joint Accounts' : user?.name}</span>
                                        <span className='summary-sub-value'>{getPriceHelper(user?.expenses_paid)}</span>
                                    </div>
                                ))
                                    : ''}
                        </div>
                    )}

                    {/* Total Unpaid Expenses */}
                    <div className='summary-item' tabIndex={0}>
                        <div className='summary-item-header'>
                            <span className='summary-item-label'>Total Unpaid Expenses</span>
                            <span className='summary-item-value'>{getPriceHelper(filteredTotalExpUnPaid) || 0}</span>
                        </div>
                    </div>
                </div>

                {/* <div className="accordion chores-accordian mt-4" id="choresAccordian">
                    <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <i className="acco-close icon-add-circle"></i><i className="acco-open icon-minus-circle"></i>Total Expenses Paid <span className="ms-auto">{getPriceHelper(totalExpPaid)}</span>
                            </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#choresAccordian">
                            <div className="accordion-body">
                                <div className="table-responsive">
                                    <table className="table chores-accordian-table m-0">
                                        <tbody>
                                            {
                                                Object.values(filteredExpPaidMembWise)?.length > 0 ? Object.values(filteredExpPaidMembWise)?.map((member: any) => (
                                                    <tr>
                                                        <td className="chores-img-wrap"><img src={member?.profile_pic} alt="" /></td>
                                                        <td>{member?.name}</td>
                                                        <td className="text-end">{getPriceHelper(member?.expenses_paid)}</td>
                                                    </tr>
                                                ))
                                                    : ''}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pay-table-view pb-3">
                    <div className="pay-table-row">
                        <div className="">Total Expenses</div>
                        <div className="">{getPriceHelper(filteredTotalExp)}</div>
                    </div>
                    <div className="pay-table-row">
                        <div className="">Total Paid Expenses</div>
                        <div className="">{getPriceHelper(filteredTotalExpPaid)}</div>
                    </div>
                    <div className="pay-table-row">
                        <div className="">Total Unpaid Expenses</div>
                        <div className="">{getPriceHelper(filteredTotalExpUnPaid)}</div>
                    </div>
                </div> */}

            </div>


            {/*==== SHARE BETWEEN MODAL START ====*/}
            <div className="modal fade bottom-sheet-modal" id="sharedBetweenModal" tabIndex={-1} aria-labelledby="sharedBetweenModalLabel" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        {/* Bottom Sheet Handle */}
                        <div className="bottom-sheet-handle">
                            <div className="handle-bar"></div>
                        </div>
                        <div className="modal-header pt-0">
                            <h1 className="modal-title" id="sharedBetweenModalLabel">Shared Between</h1>
                        </div>
                        <div className="modal-body">
                            <ul className='shared-bw-list'>
                                {
                                    sharedBetweenMemb?.length > 0 ?
                                        sharedBetweenMemb?.map((memb: any, idx: number) => (
                                            <li key={idx} className="d-flex align-items-center">
                                                <img
                                                    src={memb?.split_user?.profile_pic || memb?.split_user?.profilePic || dummyUser}
                                                    alt={memb?.split_user?.name || 'Member'}
                                                    className="member-avatar"
                                                />
                                                <span className="member-name">{memb?.split_user?.name}</span>
                                            </li>
                                        ))
                                        : ''}
                            </ul>
                        </div>
                        <div className='modal-footer border-0 pt-0 pb-4'>
                            <button className='com-btn w-100' data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            {/*==== SHARE BETWEEN MODAL END ====*/}
        </>
    )
}

export default ExpensesReport



{/*import React from 'react'

const ExpensesReport = () => {
    return (
        <>
           <div className='dark-bg page-padding-x pb-4'>
                <form className='pb-4'>
                    <div className='row'>
                        <div className='col-6'>
                            <div className="mb-3 com-input-grp">
                                <label className="form-label">Start Date</label>
                                <input
                                    type='date'
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className="mb-3 com-input-grp">
                                <label className="form-label">End Date</label>
                                <input
                                    type='date'
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='custom-select'>
                                <Select
                                    defaultValue={selectedCategory}
                                    // onChange={setSelectedOption}
                                    options={categoryOption}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    // menuIsOpen
                                    placeholder="Type of Expense "
                                />
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='custom-select'>
                                <Select
                                    defaultValue={selectedPaid}
                                    // onChange={setSelectedOption}
                                    options={paidOption}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    // menuIsOpen
                                    placeholder="Member/Payer"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="com-input-grp mt-3">
                        <label className="form-label">Amount</label>
                        <div className='amount-input'>
                            <input type="text" className="form-control" placeholder='Amount' />
                            <span className='amount-input-symbol'>$</span>
                        </div>
                    </div>
                </form>
                <div className='table-responsive report-table'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Member Name/Paid by</th>
                                <th>Expense Type</th>
                                <th>Description</th>
                                <th>Amount</th>
                                <th>Individual Share</th>
                                <th>Shared Between</th>
                                <th>Payment Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>07/01/2024</td>
                                <td>Jhone Doe</td>
                                <td>Heating</td>
                                <td>Lorem ipsum dolor sit amets.</td>
                                <td>$100.00</td>
                                <td>$10.00</td>
                                <td>Jhone... <button type='button' data-bs-toggle="modal" data-bs-target="#sharedBetweenModal" className='view-shared'>View</button></td>
                                <td className='pay-status'>Paid</td>
                            </tr>
                            <tr>
                                <td>07/01/2024</td>
                                <td>Jhone Doe</td>
                                <td>Heating</td>
                                <td>Lorem ipsum dolor sit amets.</td>
                                <td>$100.00</td>
                                <td>$10.00</td>
                                <td>Jhone... <button type='button' data-bs-toggle="modal" data-bs-target="#sharedBetweenModal" className='view-shared'>View</button></td>
                                <td className='pay-status'>Unpaid</td>
                            </tr>
                            <tr>
                                <td>07/01/2024</td>
                                <td>Jhone Doe</td>
                                <td>Heating</td>
                                <td>Lorem ipsum dolor sit amets.</td>
                                <td>$100.00</td>
                                <td>$10.00</td>
                                <td>Jhone... <button type='button' data-bs-toggle="modal" data-bs-target="#sharedBetweenModal" className='view-shared'>View</button></td>
                                <td className='pay-status'>Paid</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="pay-table-view py-3 page-padding-x">
                <div className="pay-table-row fw-600">
                    <div className="">Total Expenses</div>
                    <div className="">$50.00</div>
                </div>
                <div className="pay-table-row fw-600">
                    <div className="">Total Paid Expenses</div>
                    <div className="">$50.00</div>
                </div>
                <div className="pay-table-row fw-600">
                    <div className="">Total Unpaid Expenses</div>
                    <div className="">$50.00</div>
                </div>
            </div>
            <div className="modal fade inner-modal com-modal" id="sharedBetweenModal" tabIndex={-1} aria-labelledby="sharedBetweenModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title" id="sharedBetweenModalLabel">Shared Between</h1>
                        </div>
                        <div className="modal-body">
                            <ul className='shared-bw-list'>
                                <li>Jhone</li>
                                <li>Jhone</li>
                                <li>Jhone</li>
                                <li>Jhone</li>
                            </ul>
                        </div>
                        <div className='modal-footer border-0 mt-3'>
                            <button className='com-btn com-btn-gray mx-auto' data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExpensesReport  */}